
import lvt from "../../assets/home/categories-lvt.jpg";
import paneles from "../../assets/home/categories-paneles.jpg";
import spc from "../../assets/home/categories-spc.jpg";
import wpcExterior from "../../assets/home/categories-wpc-exterior.jpg";
import wpcInterior from "../../assets/home/categories-wpc-interior.jpg";

function Categories() {

    return (
        <>
            <section className="section-menu-gallery">
                <a className="gallery-img-text" href="/categoria/wpc/interior">
                    <img className="object-position-1" src={wpcInterior} alt="wpc interior"/>
                    <span>COLECCIÓN</span>
                    <span>WPC INTERIOR</span>
                </a>

                <a className="gallery-img-text gallery-low" href="/categoria/spc">
                    <img src={spc} alt="spc"/>
                    <span>COLECCIÓN</span>
                    <span>SPC</span>
                </a>
                <a className="gallery-img-text" href="/categoria/lvt">
                    <img src={lvt} alt="lvt"/>
                    <span>COLECCIÓN</span>
                    <span>LVT</span>
                </a>
                <a className=" gallery-img-text gallery-low" href="/categoria/Paneles%20Decorativos">
                    <img className="object-position-2" src={paneles} alt="paneles decorativos"/>
                    <span>PANELES</span>
                    <span>DECORATIVOS</span>
                </a>
                <a className="gallery-img-text" href="/categoria/wpc/exterior" >
                    <img src={wpcExterior} alt="wpc exterior"/>
                    <span>COLECCIÓN</span>
                    <span>WPC EXTERIOR</span>
                </a>
            </section>
        </>
    );
}

export default Categories;